import script from "./PendingFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./PendingFooter.vue?vue&type=script&lang=ts&setup=true"

import "./PendingFooter.vue?vue&type=style&index=0&id=768fcc98&lang=scss"

const __exports__ = script;

export default __exports__